import Vue from 'vue';
import CampusDuringWar from './Universities.vue';

export default function() {
  Vue.component('campus-during-war-universities', CampusDuringWar);
}
